import { useTranslation } from "react-i18next";

const SECTIONS = [
  { id: 1, type: "content" },
  { id: 2, type: "list", points: 6 },
  { id: 3, type: "list", points: 6 },
  { id: 4, type: "list", points: 5 },
  { id: 5, type: "list", points: 4 },
  { id: 6, type: "content" },
  { id: 7, type: "list", points: 4 },
  { id: 8, type: "content" },
  { id: 9, type: "list", points: 5 },
  { id: 10, type: "content" },
  { id: 11, type: "content" },
  { id: 12, type: "content" },
  { id: 13, type: "content" },
];

const headingClass = (language) =>
  language === "en"
    ? "text-xl md:text-3xl"
    : "text-lg md:text-2xl";

const bodyClass = (language) =>
  language === "en"
    ? "text-base md:text-xl leading-8"
    : "text-base md:text-lg leading-8";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="w-[97%] md:w-[90%] mx-auto py-6">
      <h1
        className={`text-center mb-4 ${
          i18n.language === "en"
            ? "text-3xl md:text-5xl"
            : "text-2xl md:text-4xl"
        }`}
      >
        {t("privacy.title")}
      </h1>

      <p className={`text-center mb-8 opacity-70 ${bodyClass(i18n.language)}`}>
        {t("privacy.lastUpdated")}
      </p>

      <p className={`mb-10 ${bodyClass(i18n.language)}`}>{t("privacy.intro")}</p>

      {SECTIONS.map(({ id, type, points }) => {
        const baseKey = `privacy.section${id}`;

        return (
          <div key={id} className="mb-8">
            <h2 className={`font-semibold mb-4 ${headingClass(i18n.language)}`}>
              {t(`${baseKey}.title`)}
            </h2>

            {type === "content" && (
              <p className={bodyClass(i18n.language)}>{t(`${baseKey}.content`)}</p>
            )}

            {type === "list" && (
              <ul className="list-disc pl-6 space-y-2">
                {Array.from({ length: points }, (_, index) => (
                  <li key={index} className={bodyClass(i18n.language)}>
                    {t(`${baseKey}.point${index + 1}`)}
                  </li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PrivacyPolicy;
